import IUpdateNonWorkingPeriodRequestModel from "interfaces/Request/IUpdateNonWorkingPeriodRequestModel";
import { GlobalState } from "little-state-machine";

export const updateEditNonWorkingPeriodRequest = (
  state: GlobalState,
  editNonWorkingPeriodRequest: IUpdateNonWorkingPeriodRequestModel
) => ({
  ...state,
  editNonWorkingPeriodRequest
});
